//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[[],"RefreshRegisteredInstances",{},0,0],[["numInstances","ownerParts"],"GetInstanceNames",{R_:{names:""}},0,0],[["ownerParts","names"],"SetInstanceNames",{},2,0],[["instanceName","ownerPart","tagListDetails","isHMIVisibleOnly","dataBlockFilterList"],"GetInstanceUpdateOptions",{},2,0],[["instanceName","ownerPart","tagListDetails","isHMIVisibleOnly","dataBlockFilterList"],"SetInstanceUpdateOptions",{},5,0],[["instanceName","ownerPart","bIsDataBlockFilterToggledON","bIshwCNExportFileToggledON","hwCNExportFile"],"GetInstanceUpdateExtraOptions",{},2,0],[["instanceName","ownerPart","bIsDataBlockFilterToggledON","bIshwCNExportFileToggledON","hwCNExportFile"],"SetInstanceUpdateExtraOptions",{},5,0],[["instanceName","ownerPart"],"UpdateInstance",{},2,0],[["instanceName","ownerPart","numTags","tagInfos","cyclic","stepFactor"],"GetInstanceInformationV2",{},2,0],[["instanceName","ownerPart","tagInfos","cyclic","stepFactor"],"SetInstanceInformationV2",{},5,0],[["instanceName","ownerPart"],"GetInstanceFlagOfResetPLCMemory",{R_:{bResetPLC:''}},2,0],[["instanceName","ownerPart","bResetPLC"],"SetInstanceFlagOfResetPLCMemory",{},3,0],[["instanceName","ownerPart","tagName","byteOffset","bitOffset"],"GetTagAddress",{R_:{source:''}},3,0],[["instanceName","ownerPart","tagName","byteOffset","bitOffset","source"],"SetTagAddress",{},6,0],[["instanceName","ownerPart","tagName"],"GetTagComment",{R_:{comment:''}},3,0],[["instanceName","ownerPart","tagName","comment"],"SetTagComment",{},4,0]],[]];
SPLM.Mechatronics.PlcSimAdvClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.PlcSimAdvClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.PlcSimAdvClientBuilder.TagInfo = class{
    constructor(name,eAreaType,eIOType,eDataType,bChecked){
        this.name=name;this.eAreaType=eAreaType;this.eIOType=eIOType;this.eDataType=eDataType;this.bChecked=bChecked;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eareatype(){return this.eAreaType}
    set Eareatype(val){this.eAreaType = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Bchecked(){return this.bChecked}
    set Bchecked(val){this.bChecked = val}
};

SPLM.Mechatronics.PlcSimAdvClientBuilder.TagInfoV2 = class{
    constructor(name,eAreaType,eIOType,dataType,bChecked){
        this.name=name;this.eAreaType=eAreaType;this.eIOType=eIOType;this.dataType=dataType;this.bChecked=bChecked;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eareatype(){return this.eAreaType}
    set Eareatype(val){this.eAreaType = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Datatype(){return this.dataType}
    set Datatype(val){this.dataType = val}
    get Bchecked(){return this.bChecked}
    set Bchecked(val){this.bChecked = val}
};

SPLM.Mechatronics.PlcSimAdvClientBuilder.AreaType = Object.freeze({
    "Unknow" : "Unknow", "Input" : "Input", "Output" : "Output", "Marker" : "Marker", "Datablock" : "Datablock", "Counter" : "Counter", "Timer" : "Timer"});

export default SPLM;